import { useCallback } from 'react';
import { useSelector } from '@xstate/react';

import { useGlobalMachinesContext } from 'contexts';
import { selectIsAuthenticatedUser } from 'state-machines/session';
import type { EngagementType } from 'types';
import { ignorePromiseRejection } from 'utils/helpers';
import { log } from 'utils/log';
import { createUrl } from 'utils/url';

import { useSitecoreContext } from './useSitecoreContext';

export function useEngagementGoals() {
	const { sessionService } = useGlobalMachinesContext();
	const isAuthenticatedUser = useSelector(
		sessionService,
		selectIsAuthenticatedUser,
	);
	const { sitecoreContext } = useSitecoreContext();

	const sendEngagementRequest = useCallback(
		async (props: EngagementType) => {
			try {
				await fetch(
					// TODO: It seems that the body here is pointless since Sitecore supposedly doesn't use it
					// remove it and just use query in some future. For now, query is just there for Application
					// insights visibility.
					createUrl('/api/tracking/engagement/', { type: props.type }),
					{
						method: 'POST',
						headers: {
							'content-type': 'application/json',
						},
						body: JSON.stringify({
							type: props.type,
							pageId: sitecoreContext.route?.itemId,
							loggedIn: isAuthenticatedUser,
							...('data' in props && props.data),
						}),
					},
				);
			} catch (error) {
				log.error(error);
			}
		},
		[sitecoreContext, isAuthenticatedUser],
	);

	const sendEngagement = useCallback(
		(props: EngagementType) =>
			ignorePromiseRejection(sendEngagementRequest(props)),
		[sendEngagementRequest],
	);

	return { sendEngagement };
}
